import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Se monta en la ruta /auth. Si el usuario YA tiene token (sesión activa), lo
 * redirige a `/` para que el AuthGuard cargue el perfil y los force-redirects
 * existentes (owner → /owner/dashboard, security → /security/control, etc.)
 * lo lleven al menú principal de su rol.
 *
 * Si no hay token, deja entrar al login/register/forgot normalmente.
 */
@Injectable({
    providedIn: 'root'
})
export class LoggedInRedirectGuard {
    constructor(private router: Router) {}

    canActivate(): boolean {
        const hasToken = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (hasToken) {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}
